import { render, staticRenderFns } from "./ToolbarDirectories.vue?vue&type=template&id=47a64088&scoped=true&"
import script from "./ToolbarDirectories.vue?vue&type=script&lang=js&"
export * from "./ToolbarDirectories.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarDirectories.vue?vue&type=style&index=0&id=47a64088&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a64088",
  null
  
)

export default component.exports